import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3" }
const _hoisted_2 = { class: "truncate text-lg" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "space-y-3" }

import type { PageSection } from "@/apps/page/page.interfaces";
import {
    BlockDefinition,
    BlockDefinitionGroup,
    BlockDefWithType,
    BlockTypeGroup,
} from "@/apps/page/services/blocks/block.interfaces";
import { useBlocks } from "../../../../services/blocks/useBlocks";
import { useFocusOnEditSection } from "../../../../services/useFocusOnEditSection";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { BlockBaseElement, BlockDataValue } from "@/views/blocks/PageBlock.interface";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { CardToggle } from "@easy/ui/cards";
import { FormSwitch } from "@easy/ui/forms";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { PageSidebar } from "@easy/ui/page-components";
import { computed } from "vue";
import { t } from "@/i18n";
import PageColors from "@/apps/page/project/sidebar/sections/PageColors.vue";
import BlockFieldGroups from "./components/BlockFieldGroups.vue";
import { ThemeColors } from "@/shared/themes/Theme.interface";
import { useActions, useState } from "@/store/vuex-composition-mappers";
import { defaultSaveModalConfig } from "@/shared/modals/default-save-modal.config";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditBlock',
  props: /*@__PURE__*/_mergeModels({
    section: {}
  }, {
    "selectedTab": { type: String, default: "content" },
    "selectedTabModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["saveBlock", "cancelBlock"], ["update:selectedTab"]),
  setup(__props: any, { emit: __emit }) {


const emit = __emit;
const selectedTab = _useModel(__props, "selectedTab");

// @ts-expect-error - TODO MJ: Fix types
const { hasChanges } = useState("page", ["hasChanges"]);
// @ts-expect-error - TODO MJ: Fix types
const { showConfirmModal } = useActions("modals", ["showConfirmModal"]);
const { getBlockWithTypeMetadata, groupTypes } = useBlocks();
const blockWithMetadata = computed<BlockDefWithType | null>(() =>
    __props.section.typeId ? getBlockWithTypeMetadata(__props.section.typeId, __props.section.type) : null
);

const groupedDataFields = computed(() => {
    return groupTypes.value.reduce<
        Record<BlockDefinitionGroup, BlockDefinition<BlockBaseElement<BlockDataValue>>[]>
    >(
        (
            acc: Record<BlockDefinitionGroup, BlockDefinition<BlockBaseElement<BlockDataValue>>[]>,
            type: BlockTypeGroup
        ) => {
            const fields =
                blockWithMetadata.value?.block?.dataFields.filter(
                    (field) => field.group === type.group
                ) ?? [];

            acc[type.group] = fields;

            return acc;
        },
        {} as Record<BlockDefinitionGroup, BlockDefinition<BlockBaseElement<BlockDataValue>>[]>
    );
});

const styleGroupNames = ["formatting"];

const contentGroupTypes = computed(() =>
    groupTypes.value.filter((gt) => !styleGroupNames.includes(gt.group))
);

const stylesGroupTypes = computed(() =>
    groupTypes.value.filter((gt) => styleGroupNames.includes(gt.group))
);

const saveButtonText = computed(() => t("shared.save"));

const tabs = computed(() => [
    {
        label: t("page.block.content"),
        value: "content",
    },
    {
        label: t("page.block.styles"),
        value: "styles",
    },
]);

useFocusOnEditSection();

async function saveBlock() {
    if (!__props.section._created) {
        __props.section._changed = true;
    }
    emit("saveBlock");
}

async function cancelBlock() {
    if (hasChanges.value) {
        const action = await showConfirmModal(defaultSaveModalConfig());
        if (action) {
            return saveBlock();
        }
    }
    emit("cancelBlock");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PageSidebar), null, {
    sidebarTitle: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ButtonSecondaryIconSm), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelBlock()))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowLeftIcon))
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("page.sections.edit_section")) + " - " + _toDisplayString(blockWithMetadata.value?.blockType.title), 1)
      ])
    ]),
    sidebarMain: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(FormSwitch), {
          modelValue: selectedTab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedTab).value = $event)),
          options: tabs.value
        }, null, 8, ["modelValue", "options"])
      ]),
      (selectedTab.value === 'content')
        ? (_openBlock(), _createBlock(BlockFieldGroups, {
            key: 0,
            "group-types": contentGroupTypes.value,
            "grouped-data-fields": groupedDataFields.value,
            section: _ctx.section
          }, null, 8, ["group-types", "grouped-data-fields", "section"]))
        : (selectedTab.value === 'styles')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(CardToggle), {
                title: _ctx.$t('page.block.colors')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockWithMetadata.value?.block?.styleFields, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field.value
                      }, [
                        (field.type === 'color')
                          ? (_openBlock(), _createBlock(PageColors, {
                              key: 0,
                              title: field.name,
                              modelValue: _ctx.section.styleValues[field.value as keyof ThemeColors],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.section.styleValues[field.value as keyof ThemeColors]) = $event)
                            }, null, 8, ["title", "modelValue", "onUpdate:modelValue"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(BlockFieldGroups, {
                "group-types": stylesGroupTypes.value,
                "grouped-data-fields": groupedDataFields.value,
                section: _ctx.section,
                "show-visibility-toggle": false
              }, null, 8, ["group-types", "grouped-data-fields", "section"])
            ]))
          : _createCommentVNode("", true)
    ]),
    sidebarFooter: _withCtx(() => [
      _createVNode(cSaveButton, {
        onSave: saveBlock,
        disabled: !_unref(hasChanges),
        ctaEnabled: saveButtonText.value,
        ctaDisabled: saveButtonText.value
      }, null, 8, ["disabled", "ctaEnabled", "ctaDisabled"])
    ]),
    _: 1
  }))
}
}

})